import { NgModule } from '@angular/core';
import {
    AccordionModule,
    BannerModule,
    ButtonModule,
    ButtonToggleModule,
    CheckboxModule,
    ChipModule,
    DatepickerModule,
    DrawerModule,
    FileUploaderModule,
    FormFieldModule,
    HcNativeDateModule,
    HighlightPipeModule,
    FileSizePipeModule,
    IconModule,
    InputModule,
    ListModule,
    ModalModule,
    NavbarModule,
    PaginationModule,
    PopModule,
    ProgressIndicatorsModule,
    RadioButtonModule,
    ReleaseNotesService,
    ScrollNavModule,
    SearchBarModule,
    SelectModule,
    SidenavModule,
    SlideToggleModule,
    StepperModule,
    SortModule,
    TableModule,
    TabsModule,
    TileModule,
    ToasterModule
} from '@healthcatalyst/cashmere';

@NgModule({
    exports: [
        ButtonModule,
        NavbarModule,
        PopModule,
        TableModule,
        TabsModule,
        ScrollNavModule,
        SortModule,
        PaginationModule,
        ToasterModule,
        CheckboxModule,
        RadioButtonModule,
        FormFieldModule,
        InputModule,
        IconModule,
        SelectModule,
        ModalModule,
        SlideToggleModule,
        ChipModule,
        SearchBarModule,
        ProgressIndicatorsModule,
        HighlightPipeModule,
        FileSizePipeModule,
        AccordionModule,
        BannerModule,
        TileModule,
        DrawerModule,
        ButtonToggleModule,
        SidenavModule,
        StepperModule,
        DatepickerModule,
        HcNativeDateModule,
        ListModule,
        FileUploaderModule
    ],
    providers: [ReleaseNotesService]
})
export class CashmereModule {}
